import "./FormGenerator.css"

import SearchableDropdown from "../../components/SearchableDropdown"
import { useState, useEffect } from "react"
import { useGetBundlesMutation } from "./formApiSlice"
import { FileTextOutlined } from "@ant-design/icons"
import FormViewer from "./FormViewer"
import { selectCurrentId } from "../auth/authSlice"
import { useSelector } from "react-redux"

const FormGenerator = ({ crmId, clientId, accountId }) => {
    const userId = useSelector(selectCurrentId)

    const [bundles, setBundles] = useState([])
    const [selectedBundle, setSelectedBundle] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)
    const [isEditFormModalOpen, setEditFormModalOpen] = useState(false)

    const [getBundles, { isLoading }] = useGetBundlesMutation()

    const getBundleOptions = () => {
        return bundles.map(bundle => ({id: bundle, name: bundle.name}))
    }

    useEffect(() => {
        async function handleGetBundles() {
            try {
                const response = await getBundles({crmId, userId}).unwrap()
                if(response) {
                    setBundles(response)
                }
            } catch(err) {
                if(!err.status || err.status === "FETCH_ERROR") {
                    setErrorMessage("No Server Response")
                } else {
                    setErrorMessage(err.data?.detail)
                }
            }
        }
        handleGetBundles()
    }, [])

    const handleEditForm = async () => {
        setErrorMessage("")

        if(!clientId || !accountId || !selectedBundle) {
            return
        }

        setEditFormModalOpen(true)
    }

    return(
        <div className="form-bundle-container">
            {errorMessage && 
                <div className="support-error">
                    <p>{errorMessage}</p>
                </div>
            }
            <div className="bundle-table-header">
                <div className="form-search-dropdown">
                    <div><p>Bundle: </p></div>
                    <div className="search-dropdown">
                        <SearchableDropdown
                            options={getBundleOptions()}
                            label="name"
                            id="id"
                            selectedVal={selectedBundle?.name}
                            placeholderVal={"Select Form Bundle..."}
                            handleChange={(val, id) => setSelectedBundle(id)}
                        />
                    </div>
                </div>
                <div className='generate-forms-field'>
                    <button disabled={!clientId || !accountId || !selectedBundle} onClick={() => handleEditForm()}>Edit Forms</button>
                </div>
            </div>
            {
                selectedBundle && selectedBundle.forms?.length > 0 ?
                    <table className="bundle-table">
                        <tr><td className="bundle-table-desc">This bundle includes:</td></tr>
                        {
                            selectedBundle.forms.map(form =>  <tr><td><FileTextOutlined style={{ fontSize: '15px' }}/> {form.name}</td></tr>)
                        }
                    </table>
                    :
                    null
            }

            {
                isEditFormModalOpen &&
                <FormViewer 
                    clientId={clientId} 
                    accountId={accountId} 
                    bundle={selectedBundle}
                    openModal={isEditFormModalOpen}
                    handleModalOpen={setEditFormModalOpen}
                />
            }
        </div>
    )
}

export default FormGenerator